/**
 * Region detection by hostname.
 *
 * - `.ru` host → `'ru'` (российский сегмент, оператор ИП Годовников С. Р.)
 * - everything else (`.com`, `.app`, etc.) → `'kz'` (казахстанский сегмент, оператор ИП YESSIZ IE)
 *
 * Backend already does the same split via `middleware/detect-region.js`. Frontend mirrors
 * the same suffix check so UI (legal links, footer requisites, payment provider hints)
 * matches the segment without an extra round-trip.
 */

export type Region = 'ru' | 'kz';

export const getRegion = (): Region => {
  if (typeof window === 'undefined') return 'kz';
  const host = window.location.hostname;
  if (import.meta.env.DEV && (host === 'localhost' || host === '127.0.0.1' || /^(10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)/.test(host))) {
    return 'ru';
  }
  return host.endsWith('.ru') ? 'ru' : 'kz';
};

export const isRuRegion = (): boolean => getRegion() === 'ru';
